import React from 'react'; // TODO
// eslint-disable-next-line @typescript-eslint/interface-name-prefix

var TabContext = React.createContext(null);
export default TabContext;